import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core'
import { RootState, selectFocusedAccounts } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { distinctUntilChanged, map, takeUntil } from 'rxjs/operators'

@Component({
  selector: 'hs-single-account-selected',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['single-account-selected.component.scss'],
  templateUrl: 'single-account-selected.component.html',
})
export class SingleAccountSelectedComponent implements OnInit, OnDestroy {
  private readonly _destroyed$ = new Subject<void>()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null

  @Output() accountIdChange = new EventEmitter<number | null>()

  selectedAccounts$ = this.store.select(selectFocusedAccounts).pipe(
    distinctUntilChanged(
      // Don't produce if the array is reordered
      (a, b) => a.length == b.length && a.every(x => b.includes(x)),
    ),
  )

  areMultipleAccountsSelected$ = this.selectedAccounts$.pipe(
    map(accounts => accounts.length > 1),
    distinctUntilChanged(),
  )

  isSingleAccountSelected$ = this.selectedAccounts$.pipe(
    map(accounts => accounts.length == 1),
    distinctUntilChanged(),
  )

  constructor(private readonly store: Store<RootState>) {}

  ngOnInit(): void {
    this.selectedAccounts$
      .pipe(takeUntil(this._destroyed$))
      .subscribe(accounts => this.onAccountSelectionChanged(accounts))
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  private onAccountSelectionChanged(accounts: number[]) {
    if (accounts.length == 0) {
      this.accountIdChange.emit(null)
      return
    }
    this.accountIdChange.emit(accounts[0])
  }
}
